// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v2.users.properties.multiplex.amenities.RentalManagerUserPropertyMultiplexAmenityV2WebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type {
  UserPropertyMultiplexAmenityCreateResponseV2WebDto,
  UserPropertyMultiplexAmenityCreateV2RequestDto,
  UserPropertyMultiplexAmenityDeleteResponseV2WebDto,
  UserPropertyMultiplexAmenityDeleteV2RequestDto,
} from '../..';

export const RentalManagerUserPropertyMultiplexAmenityV2WebApiHandler_create_Path =
  '/api/web/v2/users/properties/multiplex/amenities/create';

/**
 * Create a free text property amenity on every unit in a multiplex building session
 */
export const RentalManagerUserPropertyMultiplexAmenityV2WebApiHandler_create = (
  postData: UserPropertyMultiplexAmenityCreateV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<
    never,
    UserPropertyMultiplexAmenityCreateV2RequestDto,
    UserPropertyMultiplexAmenityCreateResponseV2WebDto
  >(
    {
      endpoint: RentalManagerUserPropertyMultiplexAmenityV2WebApiHandler_create_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyMultiplexAmenityV2WebApiHandler_delete_Path =
  '/api/web/v2/users/properties/multiplex/amenities/delete';

/**
 * Delete a free text property amenity from every unit in a multiplex building session
 */
export const RentalManagerUserPropertyMultiplexAmenityV2WebApiHandler_delete = (
  postData: UserPropertyMultiplexAmenityDeleteV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<
    never,
    UserPropertyMultiplexAmenityDeleteV2RequestDto,
    UserPropertyMultiplexAmenityDeleteResponseV2WebDto
  >(
    {
      endpoint: RentalManagerUserPropertyMultiplexAmenityV2WebApiHandler_delete_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};
